module.exports = __webpack_public_path__ + "img/mprofile.43f10f61.svg";